
// Helper auxiliar (puede ser movido a utils/payments.js idealmente, pero por ahora lo inyectamos aqui)
export const extractRC = (order) => {
    if (!order) return [];

    let results = [];

    // 1. Try siigo_payment_info (Official Column)
    if (order.siigo_payment_info) {
        try {
            const parsed = JSON.parse(order.siigo_payment_info);
            if (Array.isArray(parsed) && parsed.length > 0) {
                parsed.forEach(p => {
                    if (typeof p === 'object' && p !== null) {
                        results.push({
                            name: p.name || 'RC-?',
                            id: p.id || null,
                            value: p.value || 0,
                            payment_method: p.payment_method || null // New field
                        });
                    } else {
                        results.push({ name: String(p), id: null, value: 0, payment_method: null });
                    }
                });
            }
        } catch (e) {
            if (order.siigo_payment_info.includes('RC')) {
                results.push({ name: order.siigo_payment_info, id: null });
            }
        }
    }

    // 2. Try Notes (Fallback)
    const notes = order.notes || '';

    // Match ALL occurrences of [AUTO-RC: ...]
    const matches = [...notes.matchAll(/\[AUTO-RC:\s*([^\]]+)\]/g)];
    for (const m of matches) {
        const content = m[1];
        if (content.includes('|')) {
            const [name, id] = content.split('|');
            results.push({ name: name.trim(), id: id.trim() });
        } else {
            results.push({ name: content.trim(), id: null });
        }
    }

    // 3. Extract NC (Nota Crédito) from notes
    const ncMatches = [...notes.matchAll(/\[NC\]\s*Nota Crédito:\s*([^\n]+)/g)];
    for (const ncm of ncMatches) {
        const ncName = ncm[1].trim();
        const exists = results.some(r => r.name === ncName);
        if (!exists) {
            results.push({ name: ncName, id: null, value: 0, payment_method: 'Nota Crédito', type: 'credit_note' });
        }
    }

    // Also check [NC-CANCEL] for cancel info
    const ncCancelMatch = notes.match(/\[NC-CANCEL\]\s*Cancelado por Nota Crédito\s*([^\s-]+(?:-[^\s-]+)*)/);
    if (ncCancelMatch) {
        const ncName = ncCancelMatch[1].trim();
        const exists = results.some(r => r.name === ncName);
        if (!exists) {
            results.push({ name: ncName, id: null, value: 0, payment_method: 'Nota Crédito', type: 'credit_note' });
        }
    }

    // Deduplicate by Name (merge ID if available)
    const map = new Map();
    for (const r of results) {
        const cleanName = r.name.trim();
        const existing = map.get(cleanName);

        if (!existing) {
            map.set(cleanName, r);
        } else {
            // If new one has better info, merge it
            if (r.id && !existing.id) existing.id = r.id;
            if (r.payment_method && !existing.payment_method) existing.payment_method = r.payment_method;
            if (r.type && !existing.type) existing.type = r.type;
            map.set(cleanName, existing);
        }
    }

    // Filter out invalid names (undefined, RC-?, null)
    return Array.from(map.values()).filter(r =>
        r.name &&
        r.name !== 'undefined' &&
        r.name !== 'RC-?' &&
        !r.name.includes('undefined')
    );
};
